import { render, staticRenderFns } from "./ClientListExpand.vue?vue&type=template&id=bb2babd2&"
import script from "./ClientListExpand.js?vue&type=script&lang=js&"
export * from "./ClientListExpand.js?vue&type=script&lang=js&"
import style0 from "./ClientListExpand.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports